var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "settings" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.data, height: 700 } },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "50" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createdAt",
                    label: _vm.$t("general.createdAt"),
                    width: "200",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("convertTimezone")(
                                    scope.row.createdAt,
                                    _vm.$timezone,
                                    "YY-MM-DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2043255032
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "message",
                    label: _vm.$t("general.info"),
                    width: "200",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.message.toUpperCase()) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    634759604
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "data", label: _vm.$t("general.details") },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _c("div", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("planning.routeType")) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  " " + _vm._s(scope.row.data.routeType || "-")
                                ),
                              ]),
                              _c("div", [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.$t("planning.date")) + ":"),
                                ]),
                                _vm._v(
                                  " " + _vm._s(scope.row.data.planDate || "-")
                                ),
                              ]),
                            ]),
                            scope.row.message === "manual assign"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.columns.planId")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" " + _vm._s(scope.row.data.planId)),
                                  ]),
                                  _c("div", [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.planDetails")
                                          ) + ":"
                                        ),
                                      ]),
                                    ]),
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(_vm.$t("planning.isInit")) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails.isInit
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.hasCompletedWaypoint"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .hasCompletedWaypoint
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(_vm.$t("planning.hasLocked")) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .hasLocked
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.hasAssignComplete")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .hasAssignComplete
                                                ? true
                                                : false
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.hasFailedOrders")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .hasFailedOrders
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.isAssignDriver")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .isAssignDriver
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.isAssignSuccessful"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.planDetails
                                                .isAssignSuccessful
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c("div", [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("planning.orders")) +
                                            ":"
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "ul",
                                      _vm._l(
                                        scope.row.data.orders,
                                        function (order, orderIdx) {
                                          return _c("li", { key: orderIdx }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.columns.shipmentReference"
                                                  )
                                                ) +
                                                ": " +
                                                _vm._s(
                                                  order.shipmentReference || "-"
                                                ) +
                                                " "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "save plan"
                              ? _c("div", [
                                  scope.row.data.planIds
                                    ? _c("div", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.columns.planId")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.planIds
                                                ? scope.row.data.planIds.join(
                                                    ", "
                                                  )
                                                : "-"
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.data.trucks
                                    ? _c("div", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.trucks")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.trucks
                                                ? scope.row.data.trucks
                                                    .map(function (tData) {
                                                      return tData[
                                                        "plateNumber"
                                                      ]
                                                    })
                                                    .join(", ")
                                                : "-"
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            scope.row.message === "delete routes in truck"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "unassign orders from driver"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckIndex")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckIndex || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deletedOrders")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.deletedOrders
                                            ? scope.row.data.deletedOrders.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "planning.deletedOrdersShipRef"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.orderShipRefs
                                            ? scope.row.data.orderShipRefs.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "planning.toBeUnassignedOrderIds"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.toBeUnassignedOrderIds
                                            ? scope.row.data.toBeUnassignedOrderIds.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "delete some orders" ||
                            scope.row.message ===
                              "delete some assigned orders" ||
                            scope.row.message === "delete some completed orders"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.routeStatus")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.routeStatus || "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truck")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.truck || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckIndex")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckIndex || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deletedOrders")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.deletedOrders
                                            ? scope.row.data.deletedOrders.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deleteOrders.bool1")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.bool1 || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deleteOrders.bool2")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.bool2 || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deleteOrders.bool3")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.bool3 || "-")
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "delete all orders"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.includedOrders")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.includedOrders
                                            ? scope.row.data.includedOrders.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.deletedOrders")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.deletedOrders
                                            ? scope.row.data.deletedOrders.join(
                                                ", "
                                              )
                                            : "-"
                                        )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "reorder route"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.payload")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.payload || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("general.request")) +
                                            ":"
                                        ),
                                      ]),
                                    ]),
                                    _c("ul", [
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.company")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.company ||
                                                "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.tooltip.start")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .startDateTime || "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.startIndex")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .startIndex || "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.routes")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.routes
                                                ? scope.row.data.request.routes
                                                    .map(function (r) {
                                                      return r["code"]
                                                    })
                                                    .join(", ")
                                                : "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.locked")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.locked
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.deletedOrders")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .deletedOrders
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "update route eta"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.payload")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.payload || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("general.request")) +
                                            ":"
                                        ),
                                      ]),
                                    ]),
                                    _c("ul", [
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.company")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.company ||
                                                "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.tooltip.start")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .startDateTime || "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.startIndex")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .startIndex || "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.routes")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.routes
                                                ? scope.row.data.request.routes
                                                    .map(function (r) {
                                                      return r["code"]
                                                    })
                                                    .join(", ")
                                                : "-"
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("planning.locked")) +
                                              ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request.locked
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("planning.deletedOrders")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.data.request
                                                .deletedOrders
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "update route"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.truckId")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.truckId || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.routes")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.routes
                                            ? scope.row.data.routes
                                                .map(function (r) {
                                                  return r["code"]
                                                })
                                                .join(", ")
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("planning.route")) + ":"
                                        ),
                                      ]),
                                    ]),
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.gMap.waypointType")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.waypointType." +
                                                  scope.row.data.route
                                                    .waypointType
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.status")
                                          ) +
                                            ": " +
                                            _vm._s(scope.row.data.route.status)
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.zone")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.route.zone === ""
                                                ? "-"
                                                : scope.row.data.route.zone
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.start")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                scope.row.data.route.startTime,
                                                _vm.$timezone
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.travellingTime"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm.helper.printThousandDecimal(
                                                scope.row.data.route.time / 60
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.eta")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                scope.row.data.route
                                                  .estimateTime,
                                                _vm.$timezone
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.waitingTime"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm.helper.printThousandDecimal(
                                                scope.row.data.route
                                                  .waitingTime / 60
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.handlingTime"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm.helper.printThousandDecimal(
                                                scope.row.data.route
                                                  .handlingTime / 60
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.end")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                scope.row.data.route.endTime,
                                                _vm.$timezone
                                              )
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.planId")
                                          ) +
                                            ": " +
                                            _vm._s(scope.row.data.route.planId)
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.projectCode"
                                            )
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.route.projectCode
                                                ? scope.row.data.route.projectCode.join(
                                                    ", "
                                                  )
                                                : ""
                                            )
                                        ),
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.shipRefs")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              scope.row.data.route
                                                .shipmentReference
                                                ? scope.row.data.route.shipmentReference.join(
                                                    ", "
                                                  )
                                                : ""
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.routeIndex")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.routeIndex || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("planning.tooltip.start")
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.startTime || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.routeForm")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.data.routeForm || "-")
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            scope.row.message === "log in"
                              ? _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("general.ipAddress")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.ip || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.user")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(scope.row.data.user || "-")
                                    ),
                                  ]),
                                ])
                              : _c("div", [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.user")) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.user &&
                                            scope.row.data.user.name
                                            ? scope.row.data.user.name
                                            : "-"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("planning.globalUsers")) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.data.globalUsers
                                            ? scope.row.data.globalUsers
                                                .map(function (i) {
                                                  return i["username"]
                                                })
                                                .join(", ")
                                            : "-"
                                        )
                                    ),
                                  ]),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1445567542
                  ),
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }